import { UserRoleWebComponent } from './component/UserRoleWebComponent';

export { UserRoleWebComponent };
